<component :is="component"></component>